import { useMatch } from "react-router-dom"

import { PointSelectListener } from "@l2r-front/l2r-common"
import { BASE_MAP_ID } from "@l2r-front/l2r-map"
import { MapAdapterFeature } from "@l2r-front/l2r-networks"

import { APP_DOCUMENT, MODULE_DOCUMENTS, ROADWORK_ATTACHMENT } from "../../constants/modules"
import { useElementQuery } from "../../hooks/queries/useElementQuery"

export function MapAdapterDocumentAttachedDetail() {

    const match = useMatch(`/:networkSlug/${APP_DOCUMENT}/${MODULE_DOCUMENTS}/:road/attached/:attachmentType/:attachmentId`)
    const attachmentType = match?.params?.attachmentType
    const attachmentId = match?.params?.attachmentId

    const { data: attachedObject } = useElementQuery(attachmentType, attachmentId, { enabled: !!attachmentType === ROADWORK_ATTACHMENT && !!attachmentId })

    if (attachmentType === ROADWORK_ATTACHMENT) {
        return <MapAdapterFeature feature={attachedObject} />
    }

    return <PointSelectListener mapId={BASE_MAP_ID} pointFeature={attachedObject} />
}